<template>
  <div class="item" id="pg-requirements">
    <div class="left" data-toggle="collapse" data-target="#item-requirements" aria-expanded="true" aria-controls="item-requirements">
      <p class="text-add-course">Requerimentos</p>
    </div>
    <div id="item-requirements" class="text-center rigth collapse width"  aria-labelledby="pg-requirements" data-parent="#pg-add-course">
      <div class="content-info">
        <div class="form-info">
          <div class="col-12 mb-3">
            <label>O que os alunos devem saber para fazer o seu curso?</label>
            <textarea class="form-control input-form-course" rows="4" v-model="requirements.have_to_know"/>
          </div>

          <div class="col-12 mb-3">
            <label>O que os alunos vão aprender ao terminar o curso?</label>
            <textarea class="form-control input-form-course" rows="4" v-model="requirements.will_learn" />
          </div>

          <div class="d-flex justify-content-between mt-5">
            <button
              class="btn px-3"
              data-toggle="collapse"
              data-target="#item-info"
              aria-expanded="true"
              aria-controls="item-info"
              @click="save"
            ><< Informações</button>

            <button
              class="btn px-3"
              data-toggle="collapse"
              data-target="#item-tags"
              aria-expanded="true"
              aria-controls="item-tags"
            >Tags >></button>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'add-course-requirements',
  computed: {
    ...mapGetters({
      requirements: "getNewCourseRequirement"
    })
  },
  methods: {
    ...mapActions({
      setRequirement: "setRequirement"
    }),
    save: function () {
      this.setRequirement( this.requirements )
    }
  }
}
</script>
